import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API } from "@/lib/brand";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/journal/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/auth/callback`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err?.detail || "Auth failed");
        }
        // Clear the fragment so re-mounts don't re-process
        window.history.replaceState(null, "", "/journal/admin");
        await refresh();
        navigate("/journal/admin", { replace: true });
      } catch (e) {
        toast.error(e.message || "Sign-in failed");
        navigate("/journal/admin/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-ink-soft">
      <Loader2 size={22} className="animate-spin mr-2" /> Signing you in…
    </div>
  );
}
